import { ReactNode } from 'react';
import styles from './card-wrapper.module.css';
import clsx from 'clsx';

interface CardWrapperProps {
  children: ReactNode;
  className?: string;
}

export function CardWrapper({ children, className }: CardWrapperProps) {
  return <div className={clsx(styles.wrapper, className)}>{children}</div>;
}
